module.exports = __webpack_public_path__ + "media/images/game_icon/zh-tw/AB1528-04c1f5ea96b2128ec76f7a2370cf356d.png";